class UpsellPlusButton extends HTMLElement {
  constructor() {
    super();
    this.productForm = this.querySelector('product-form');
  }

  connectedCallback() {
    this.productForm.addEventListener('product-added', this.handleProductAdded.bind(this));
    this.productForm.addEventListener('product-error', this.handleProductError.bind(this));
  }

  handleProductAdded(event) {
    this.querySelector('[data-icon-plus]').classList.add('hidden');
    this.querySelector('[data-icon-check]').classList.remove('hidden');
    this.querySelector('[data-icon-check]').classList.add('flex');
  }

  handleProductError(event) {
    this.querySelector('[data-icon-plus]').classList.remove('hidden');
    this.querySelector('[data-icon-check]').classList.add('hidden');
  }
}

customElements.define('upsell-plus-button', UpsellPlusButton);